import { generateClient } from 'aws-amplify/api';
import { Amplify } from 'aws-amplify';
import Cookies from 'universal-cookie';

// GraphQL subscription for marketing banner updates
export const marketingSubscription = /* GraphQL */ `
  subscription Subscribe($name: String!) {
    subscribe(name: $name) {
      name
      data
    }
  }
`;

/**
 * Subscribe to marketing banner updates from AppSync
 * @param {Function} onNext - Callback function to handle new marketing messages
 * @param {Function} onError - Callback function to handle errors
 * @returns {Object} Subscription object with unsubscribe method
 */
export function subscribeToMarketingUpdates(onNext, onError = console.error) {
  try {
    const client = generateClient();
    let token = new Cookies().get('web-editor-token');

    const subscription = client
      .graphql({
        query: marketingSubscription,
        variables: { name: 'marketing' },
        authToken: token,
        authMode: 'lambda',
      })
      .subscribe({
        next: ({ data }) => {
          if (data?.subscribe?.data) {
            try {
              // Parse the JSON data from the Channel.data field
              const marketingData = JSON.parse(data.subscribe.data);

              // Check if this is a banner disable action
              if (marketingData.action === 'banner_disabled') {
                onNext({ action: 'hide' });
                return;
              }

              // Handle the marketing banner data structure for showing banner
              if (marketingData.message || marketingData.banner) {
                const bannerData = marketingData.banner || marketingData;
                onNext({
                  action: 'show',
                  message: bannerData.message,
                  startDate: bannerData.startDate,
                  endDate: bannerData.endDate,
                  maintenanceMode: bannerData.maintenanceMode,
                });
              }
            } catch (parseError) {
              console.error(
                'Failed to parse marketing subscription data:',
                parseError,
              );
              onError(parseError);
            }
          }
        },
        error: (error) => {
          console.error('Marketing subscription error:', error);
          onError(error);
        },
        complete: () => {
          console.log('Marketing subscription completed');
        },
      });

    return subscription;
  } catch (error) {
    console.error('Failed to setup marketing subscription:', error);
    onError(error);
    return null;
  }
}

/**
 * Configure AWS Amplify for AppSync
 * This should be called during app initialization
 */
export function configureAppSync() {
  // This configuration should match your AppSync endpoint
  // In a real app, these values would come from environment variables or config
  const config = {
    API: {
      GraphQL: {
        endpoint: `${window.location.origin.replace(/^http/, 'ws')}/appsync-api/graphql`,
        region: 'us-west-1',
        defaultAuthMode: 'lambda',
      },
    },
  };

  // Configure Amplify if not already configured
  try {
    Amplify.configure(config);
    console.log('AppSync configured successfully');
  } catch (error) {
    console.error('Failed to configure AppSync:', error);
  }
}
